import React from "react";
import loading from "./../../components/frontEnd/logo.png";
import "./common.css";

export default function LoadingScreen() {
  return (
    <div className="loadingScreen">
      <img src={loading} className="loadingLogo slow-animated tada infinite" />
    </div>
  );
}
